import "../index.css";
import './css/ddpiform.css'
import { Icon } from "@iconify/react";
import { useCallback, useEffect, useState } from "react";
import useRazorpay from "react-razorpay";
import mainurl from "../config/mainurl.mjs";
import { Link, useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
import secureLocalStorage from "react-secure-storage";
import Popup from "reactjs-popup";
// import { useNavigate } from "react-router-dom";
function Ddpipayment() {
  const [jsonObject, setJsonObject] = useState({});
  const orderdate = DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss");
  const [isOpenModel, setIsOpenModel] = useState(false)
  const Navigate = useNavigate();
  const [Razorpay] = useRazorpay();
  const clientcode = secureLocalStorage.getItem("CC");
  const uniquiid = secureLocalStorage.getItem("uid");
  const ddpipayament = 1;
  const [Previewpdf, setPreviewpdf] = useState("");

  const [show, setshow] = useState("");
  const [Agree, setAgree] = useState(true);
  const [isLoader, setIsLoader] = useState(false)
  const [contentData, setContentData] = useState([])
  const [content, setContent] = useState([])
  const [selectAll, setSelectAll] = useState(content.length === contentData.length)
  const [msg, setMsg] = useState('')



  const getMsg = async () => {
    const updateBodydata = jsonObject
    updateBodydata.cc = clientcode
    updateBodydata.uid = uniquiid
    console.log(updateBodydata, 'updateeeebodyData')

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: JSON.stringify(updateBodydata)
    };

    await fetch(`${mainurl}/select-ddpi-options`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setMsg(result.msgs[0].frontend_warning_msg)
      }).catch((error) => console.error(error));

    if (content.length === contentData.length) {
      redirect()
    } else {
      setIsOpenModel(true)
    }
  }

  const getData = async () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: '',
      redirect: "follow"
    };

    await fetch(`${mainurl}/preview-options`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setContentData(result.options)
      }
      )
      .catch((error) => console.error(error));
  }


  const handleChange = (e, column) => {
    let copyOfColumn = [...content];
    setSelectAll(false)
    if (e.target.checked) {
      copyOfColumn.push(column);
      setContent(copyOfColumn);
    } else {
      const filterData = copyOfColumn.filter((item) => item !== column);
      setContent(filterData);
    }
  };

  const allSelect = () => {
    setSelectAll(false)
    setContent([...contentData])
  }

  useEffect(() => {
    let copyData = []
    content.map((item) => copyData.push(item.backend_heading))
    contentData.forEach(key => {
      jsonObject[key.backend_heading] = copyData.includes(key.backend_heading);
    });
  }, [content, isOpenModel])



  async function paymentverify(pay_id, order_id, signature_id) {
    setIsLoader(true)
    secureLocalStorage.setItem("payid", pay_id);
    await fetch(`${mainurl}/paymentverify`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: JSON.stringify({
        cc: clientcode,
        uid: uniquiid,
        orderid: order_id,
        paymentid: pay_id,
        signature: signature_id,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === 202) {
          secureLocalStorage.setItem("status", `${uniquiid}pc`);
          Navigate("/paymentstatus"); //successs
        }
      });
    setIsLoader(false)
  }


  const handlePayment = useCallback(
    (ddpidpaymentapiresp) => {
      const options = {
        key: "rzp_live_ialW34MbpA2qsF",
        amount: "1",
        currency: "INR",
        name: "AGSL",
        description: "Payment for DDPI",
        image: "https://www.almondzglobal.com/images/logo.png",
        order_id: `${ddpidpaymentapiresp.order_id}`,
        handler: function (response) {
          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature)
          paymentverify(
            response.razorpay_payment_id,
            response.razorpay_order_id,
            response.razorpay_signature
          );
        },
        prefill: {
          name: `${ddpidpaymentapiresp.details.name}`,
          email: `${ddpidpaymentapiresp.details.email}`,
          contact: `${ddpidpaymentapiresp.details.mobile}`,
        },
        notes: {
          cc: clientcode,
          uid: uniquiid,
          bankname: `${ddpidpaymentapiresp.details.bankname}`,
          bankacno: `${ddpidpaymentapiresp.details.bankacno}`,
        },
        theme: {
          color: "#FB8F36",
        },
      };
      const rzpay = new Razorpay(options);
      rzpay.open();
    },
    [Razorpay]
  );

  async function newHandlePAY() {
    let razorobj = {};

    await fetch(`${mainurl}/paynow`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: JSON.stringify({
        cc: clientcode,
        uid: uniquiid,
        amt: ddpipayament,
        notes: {
          comment: "Payment for DDPI",
          cc: clientcode,
          uid: uniquiid,
          date: orderdate,
        },
      }),
    })
      .then((res) => res.text())
      .then((result) => Object.assign(razorobj, JSON.parse(result),));
    handlePayment(razorobj);
  }

  async function pdfpreviewapi() {
    var pdfobj = {};
    await fetch(`${mainurl}/printform`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: JSON.stringify({
        cc: clientcode,
      }),
    })
      .then((resp) => resp.text())
      .then((result) => {
        Object.assign(pdfobj, JSON.parse(result));
        setPreviewpdf(pdfobj.content);
        setshow(true);
      })
      .catch((error) => {
      });
  }

  const redirect = () => {
    setIsOpenModel(false)
    // IF pay flag open then remove this code
    secureLocalStorage.setItem("status", `${uniquiid}pStatus`);
    Navigate("/estampform");
    // newHandlePAY()
  };

  function clientagree(e) {
    if (e.target.checked) {
      setAgree(true);
    } else {
      setAgree(false);
    }
  }

  useEffect(() => {
    pdfpreviewapi()
    if (secureLocalStorage.getItem("status") !== `${uniquiid}oc`) {
      secureLocalStorage.clear();
      Navigate("/");
    } else {
      // pdfpreviewapi();
      getData()
    }

  }, []);



  return (
    <div className="container">
      <button className=" link-text absolute flex items-center text-sm bottom-4 left-2 sm:left-2 md:left-10">
        <Icon icon="mdi:arrow-left" />
        <Link to="https://almondztrade.com" onClick={() => secureLocalStorage.clear()}>Back to home</Link>
      </button>
      {
        isLoader ?
          <div className=" w-3/4 h-5/6 flex justify-center items-center">
            <Icon icon="line-md:loading-twotone-loop" width='50' height='50' color="orange" />
          </div>
          :
          <div className="form-container">
            <div className=" h-[85%] ">
              <div className=" p-4 lg:p-8 2xl:p-10 pb-0 lg:pb-0 2xl:pb-0 gap-4  flex flex-col justify-between">
                <div className=" text-xs lg:text-sm xl:text-[20px] font-semibold">Execute DDPI for the following</div>
                <div>
                  <button className={`text-[10px]  lg:text-xs ${content.length === contentData.length ? 'text-white bg-[#6A6CF0]' : 'text-[#373737 bg-[#d8d8d8a7]'}  px-3 py-1 rounded-full cursor-pointer`} onClick={allSelect} >Select All</button>
                </div>
              </div>
              <div className=" mt-6 flex flex-col gap-4 h-[80%] overflow-auto px-2 mx-2 lg:px-6 lg:mx-2 2xl:px-8 2xl:mx-2 ">
                {contentData.map((item, i) => (
                  <div className="flex items-start gap-4">
                    <input
                      type="checkbox"
                      className=" check-box h-4 w-4 mt-1"
                      onChange={(e) => handleChange(e, item)}
                      checked={content.includes(item)}
                    />
                    <div className="text-[10px] md:text-xs">{item.frontend_description}</div>
                  </div>
                ))}

                {/* <div className="flex items-start gap-4">
                  <input type="checkbox" className=" check-box h-4 w-4 mt-1" />
                  <div className="text-[10px] md:text-xs">Pledging/ re-pledging of securities in favor of AGSL/ the clearing member with whom AGSL is a member for the purpose of meeting my/our margin requirements in connection with the trades executed by me/us on the Stock Exchange.</div>
                </div>
                <div className="flex items-start gap-4">
                  <input type="checkbox" className=" check-box h-4 w-4 mt-1" />
                  <div className="text-[10px] md:text-xs">Mutual Fund transactions being executed on Stock Exchange order entry platforms.</div>
                </div>
                <div className="flex items-start gap-4">
                  <input type="checkbox" className=" check-box h-4 w-4 mt-1" />
                  <div className="text-[10px] md:text-xs">Tendering shares in open offers, buy-backs etc. through Stock Exchange platforms.</div>
                </div> */}
              </div>
            </div>

            <Popup open={isOpenModel} onOpen={setIsOpenModel} modal nested >
              <div className='h-full relative'>

                <div className='w-full h-2/4 flex flex-col items-center justify-center text-center'>
                  <div className="mb-4 text-[20px] font-semibold "> Important</div>
                  <div className="text-sm text-[#707070]">{msg}</div>
                </div>
                <div className=' h-2/4 absolute bottom-0 flex flex-col justify-center w-full gap-2'>
                  <div className='rounded-[12px] bg-[#FFCC4D] max-w-[380px] w-full mx-auto mb-3'>
                    <div className='ml-2 bg-white rounded-[12px]'>
                      <div className='h-[60px] bg-[#FFCC4D1A] text-[10px] md:text-xs rounded-[12px] flex items-center px-3'>
                        <div>
                          <span className='text-[#707070] font-semibold'>*Note :</span> <span className='text-[#707070]'>Once you make the payment, no changes can be made to the DDPI agreement</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button className=' outline-none border-[1.5px] border-transparent bg-bgactive_btn text-white text-xs w-[280px]  mx-auto py-2 font-semibold rounded-full' onClick={() => {
                    setIsOpenModel(false)
                  }}>
                    Change
                  </button>
                  <button className=' outline-none text-xs w-[280px]  mx-auto py-2 rounded-full bg-[#6A6CF00D] border-[1.5px] font-semibold border-[#6A6CF0]' onClick={redirect} >Continue</button>
                </div>
              </div>
            </Popup >

            {/* <div className="form-box flex justify-center items-center w-3/4 h-3/4 m-auto">
              {Previewpdf == "" ? (
                <Icon
                  icon="svg-spinners:6-dots-scale"              <div className="text-sm text-white text-[]">Select All</div>

                  color="orange"
                  width="50"
                  height="50"
                />
              ) : (
                <embed
                  src={`data:application/pdf;base64,${Previewpdf}#toolbar=0&scrollbar=0`}
                  width="100%"
                  height="100%"
                />
              )}
            </div> */}
            {/* <div className="checkinput-box flex justify-center gap-2 mt-5 mx-2 sm:px-[5vw] sm:mx-0">
              <input
                type="checkbox"
                checked={Agree == "" ? false : true}
                disabled={show == "" ? true : false}
                className=" check-box h-4 w-4 mt-1"
                onChange={(e) => clientagree(e)}
              ></input>
              <div className="text-[10px]">
                By continuing further, I give my consent to activate DDPI for all
                specific purpose(s) as mentioned in the DDPI Form.
                <p className="mt-1">*In case you do not wish to select all option then please fill Offline/Physical form.</p>

              </div>
            </div> */}
            <div className="absolute bottom-2 w-full md:bottom-4">
              <button
                className={
                  content.length === 0
                    ? "default-btn cursor-not-allowed"
                    : "active-btn"
                }
                onClick={

                  content.length === 0
                    ? () => alert("Please select any one checkbox")
                    : getMsg
                }
              >
                Continue
              </button>
            </div>
          </div>
      }

    </div>
  );
}
export default Ddpipayment;
